/*global faker*/
(function (module) {
    'use strict';
    module.config(['$provide', function ($provide) {
        //this delay all http request
        $provide.decorator('$httpBackend', ['$delegate', function ($delegate) {
            var proxy = function (method, url, data, callback, headers) {
                var interceptor = function () {
                    var _this = this,
                        _arguments = arguments;
                    setTimeout(function () {
                        callback.apply(_this, _arguments);
                    }, 1000);
                };
                return $delegate.call(this, method, url, data, interceptor, headers);
            };
            for (var key in $delegate) {
                proxy[key] = $delegate[key];
            }
            return proxy;
        }]);
    }]);
    module.run(['$httpBackend', '$rootScope', function ($httpBackend, $rootScope) {
        var getResponseError = function (message) {
            return {
                error: {
                    message: message
                }
            };
        };
        //mocking authentication
        $httpBackend.whenPOST('/auth').respond(function (method, url, data) {
            var response;
            var user = angular.fromJson(data);
            if ((user.username === 'sbonilla' || user.username === 'sbonilla@dominet.net') && user.password === '1234') {
                var httpResponse = {
                    token: faker.random.uuid()
                };
                httpResponse.user = faker.helpers.userCard();
                httpResponse.user.picture = faker.image.avatar();
                response = [ 200, httpResponse, {} ];
            } else {
                response = [ 401, getResponseError('Usuario y/o clave incorrecta'), {} ];
            }
            return response;

        });

        //mocking profile
        $httpBackend.whenGET('/profile/me').respond(function (method, url, data) {
            var response;
            var user = faker.helpers.userCard();
            user.picture = faker.image.avatar();
            return [ 200, user, {} ];
        });

    }]);
}(angular.module('mockApp', [ 'emarket', 'ngMockE2E' ])));
